import StudentAddModal from './StudentAddModal'

export default StudentAddModal
